import { Link } from "react-router-dom";
import JoinModal from "../../Layout/Modal/JoinModal";
const Launch = () => {
  return (
    <>
      <section className="Launch">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="terminal">
                <div className="heading">
                  <h4>Empower Your Journey with Zeuss Token</h4>
                  <p>
                    Join the decentralized revolution and explore limitless
                    opportunities with Zeuss Token's innovative ecosystem.
                  </p>
                  <JoinModal />
                  {/* <Link to="" className="apply">
                    <img src="/images/arrow.png" alt="" />
                    Join The Pre Sale
                  </Link> */}
                </div>
                <div className="image">
                  <img src="/images/terminalrocket.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Launch;
